import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import {
    currentSearchPivotKey,
    currentFilterKey,
    selectedResultFilter,
} from '../selectors/searchViewSelectors';
import { getSearchableAsset } from 'owa-timestream-asset-search';
import { setCurrentFilterKey } from '../mutators/searchViewMutators';
import { ActionButton } from '@fluentui/react/lib/Button';
import { searchRefinersButtonTitle } from 'owa-locstrings/lib/strings/searchrefinersbuttontitle.locstring.json';
import loc from 'owa-localize';

export default observer(function ResultsFilter() {
    const selectedKey = currentFilterKey();
    const searchPivotKey = currentSearchPivotKey();

    const [refinersVisible, setRefinersVisible] = React.useState<boolean>(false);

    const onFilterButtonClicked = React.useCallback(
        (evt: React.MouseEvent<HTMLButtonElement>) => {
            evt.stopPropagation();
            setRefinersVisible(!refinersVisible);
        },
        [refinersVisible]
    );
    const onCalloutDismiss = React.useCallback(
        (evt: React.MouseEvent<HTMLButtonElement>) => {
            evt.stopPropagation();
            setRefinersVisible(!refinersVisible);
        },
        [refinersVisible]
    );
    const onItemClicked = React.useCallback(
        (evt?: React.MouseEvent<HTMLButtonElement>, item?: IContextualMenuItem) => {
            evt.preventDefault();
            evt.stopPropagation();
            setCurrentFilterKey(item.key);

            // close the menu after selection since we only support single selection
            setRefinersVisible(false);
        },
        []
    );

    const searchableAsset = getSearchableAsset(searchPivotKey);
    const getFilterOptionsFunction = searchableAsset?.getResultFilterOptions;
    const filterOptions = getFilterOptionsFunction ? getFilterOptionsFunction() : [];

    // we depend on getFilterOptionsFunction instead of filterOptions directly because filterOptions is an array reference that changes even if data inside doesn't necessarily change.
    // getFilterOptionsFunction only updates when the underlying store value changes.
    React.useEffect(() => {
        if (filterOptions.length > 0) {
            setCurrentFilterKey(filterOptions[0].id);
        }
    }, [getFilterOptionsFunction]);

    const refinersButton = React.useRef(null);
    if (!filterOptions || filterOptions.length === 0) {
        return null;
    }

    const items: IContextualMenuItem[] = filterOptions.map(filterOption => {
        return {
            key: filterOption.id,
            text: filterOption.label,
            canCheck: true,
            isChecked: selectedKey === filterOption.id,
            onClick: onItemClicked,
        };
    });

    return (
        <div className={styles.resultsFilterWrapper}>
            <ActionButton
                ref={refinersButton}
                className={styles.refinersButton}
                menuIconProps={{ iconName: ControlIcons.ChevronDown }}
                onClick={onFilterButtonClicked}
                title={loc(searchRefinersButtonTitle)}
                menuProps={{
                    items: items,
                    target: refinersButton,
                    onDismiss: onCalloutDismiss,
                }}>
                {selectedResultFilter()?.label}
            </ActionButton>
        </div>
    );
});
